export default {"src":"/_next/static/media/chevron_left.168f99d9.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};